import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  BooleanInput,
  required,
  SelectInput,
  ReferenceInput,
  useGetIdentity,
  TopToolbar,
  ListButton,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import WsCampaignUrlHelp from '../../components/WsCampaignUrlHelp'

const WsCampaignsEditActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
  </TopToolbar>
)

WsCampaignsEditActions.propTypes = {
  basePath: PropTypes.any,
}

export const WsCampaignsEdit = props => {
  const translate = useTranslate()
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <Edit actions={<WsCampaignsEditActions />} {...props}>
      <TabbedForm submitOnEnter={false} syncWithLocation={false}>
        <FormTab label={translate('surveys.campaigns.tab_summary_form')}>
          <ReferenceInput
            label={translate('surveys.resources.campaign')}
            source="campaign_id"
            reference="campaigns"
          >
            <SelectInput optionText="name" fullWidth />
          </ReferenceInput>
          <WsCampaignUrlHelp />
          <TextInput
            source="url_ws"
            label="URL WS"
            validate={required()}
            fullWidth
            multiline
            minRows={3}
          />
          <BooleanInput source="status" />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}
